import React from "react";
import Infographic from "../Infographic/Infographic";
import "./Sections.scss";

function Section5() {
  return (
    <section className="sections">
      <div className="sections-section2">
        <Infographic />
        <p className="sections-copy sections-copy--section5">
          But even if buyers can buy a home with a petite down payment, that’s
          not always the smartest choice from a financial standpoint. Putting
          down more money up-front may help buyers obtain a lower interest rate
          and potentially avoid having to pay for mortgage insurance. A mortgage
          broker or housing counselor can help buyers figure out what size down
          payment makes the most sense.
        </p>
        <p className="sections-copy">
          Of course, buyers also need to keep an eye on the big picture and make
          sure the home they want fits into their overall budget and financial
          situation. Well before taking any home tours or making any offers,
          buyers should obtain their credit score and calculate their
          debt-to-income ratios. Here too, mortgage brokers may be able to
          provide buyers with valuable information on how to improve their
          credit scores and can provide guidance on what price range a buyer can
          actually afford and what size loan they might be able to secure.
        </p>
      </div>
    </section>
  );
}

export default Section5;
